import Button from 'Components/Base/Button'
import { AxiosResponse } from 'axios'
import dayjs from 'dayjs'
import { useAppDispatch, useAppSelector } from 'hooks/hooks'
import useNewEnrollment from 'hooks/useNewEnrollment'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getAccessToken } from 'reducers/authSlice'
import { setLoading } from 'reducers/tempSlice'
import styled from 'styled-components'
import { formatTimeAndTimezone } from 'utilities/formatTimeAndTimezone'

interface props {
  handleNextStep: Function
  ctl: boolean
}

export default function Confirmation({ handleNextStep, ctl }: props) {
  const [scheduledAppointment, setScheduledAppointment] = useState<string | undefined>()
  const [triaPerson, setTriaPerson] = useState<string>('Tria')

  const navigate = useNavigate()
  const token = useAppSelector(getAccessToken)
  const { getInitial } = useNewEnrollment({ token: token })
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setLoading(true))
    getInitial({ ctl: ctl, pa: !ctl })
      .then((res: AxiosResponse<{ scheduledAppointment: string; triaPerson: string }>) => {
        const { scheduledAppointment, triaPerson } = res.data
        triaPerson && setTriaPerson(triaPerson)
        scheduledAppointment && setScheduledAppointment(scheduledAppointment)
      })
      .then(() => dispatch(setLoading(false)))
      .catch(() => {
        dispatch(setLoading(false))
        navigate('/error')
      })
  }, [])

  return (
    <Card>
      <Header>You're Scheduled!</Header>
      <BestFor>
        You’re scheduled to meet with <b>{triaPerson}</b> on <b>{dayjs(scheduledAppointment).format('MMM DD, YYYY')}</b> at{' '}
        <b>{formatTimeAndTimezone(scheduledAppointment ?? '')}</b>.
      </BestFor>
      <Expect style={{ color: '#9F2842' }}>
        <b>REQUIRED - IMPORTANT NEXT STEP:</b>
      </Expect>
      <BestFor>
        To make the most of your upcoming call, please fill out a quick form with some basic health info. It only takes a few minutes!
      </BestFor>
      <Button width={300} backgroundColor="#9F2842" text="Complete My Form" onClick={() => handleNextStep()} />
    </Card>
  )
}

const Card = styled.div`
  border-radius: 34px;
  max-width: 1200px;
  min-width: 1200px;
  min-height: 600px;
  border: 1px solid #bdbdbd;
  font-family: Raleway;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 80px;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 100px 20px 20px;
  @media only screen and (max-width: 600px) {
    margin-top: 20px;
    min-width: 90%;
    padding: 40px 20px;
    margin: 20px 10px;
  }
`

const Header = styled.h1`
  font-weight: 700;
  font-size: 40px;
  margin-bottom: 20px;
`

const BestFor = styled.p`
  font-size: 20px;
  margin-bottom: 60px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
`

const Expect = styled.p`
  font-size: 22px;
  margin-bottom: 20px;
`

const Li = styled.li`
  margin-bottom: 10px;
`
